<template>
    <v-row no-gutters>
        <v-col cols="12">
            <DomainBar :accountId="$route.params.accountId" :domain="$route.params.domain" class="mb-6"></DomainBar>
            <AccessDeniedOverlay v-if="forbiddenError"></AccessDeniedOverlay>
            <!-- hierarchical navigation -->
            <!-- <v-row justify="start" class="mt-2 mx-4">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <p class="text-caption text-start">
                    <router-link :to="{ name: 'user-dashboard' }">Dashboard</router-link> &gt;
                    <router-link :to="{ name: 'user-account-list' }">Accounts</router-link>
                    <template v-if="account">
                    &gt;
                    <router-link :to="{ name: 'account-dashboard', params: { accountId: this.$route.params.accountId } }">{{ account.name }}</router-link>
                    </template>
                </p>
                </v-col>
            </v-row> -->
            <v-row justify="center" class="py-5 px-10 mt-8">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">

                    <v-card>
                        <v-toolbar color="red darken-2 white--text" dark flat dense>
                        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
                            <v-toolbar-title>
                                Delete domain
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-progress-circular indeterminate size="16" width="2" color="white" v-if="!account || !domain"/>
                        </v-toolbar>
                        <v-card-text v-if="account && domain">
                            <table class="kv">
                                <tbody>
                                    <tr>
                                        <th>Account name</th>
                                        <td>{{ account.name }}</td>
                                    </tr>
                                    <tr>
                                        <th>Domain name</th>
                                        <td>{{ domain.name }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- <p class="text-overline mb-0">Account name</p>
                            <p class="mb-0 pb-0">
                                {{ account.name }}
                            </p>

                            <p class="text-overline mb-0 mt-4">Domain name</p>
                            <p class="mb-0 pb-0">
                                {{ domain.name }}
                            </p> -->

                            <template v-if="domain && Array.isArray(dnsRecordList)">
                            <p class="text-overline mb-0 mt-4">DNS Records ({{ dnsRecordList.length }})</p>
                            <p class="mb-0 pb-0" v-if="dnsRecordList.length === 0">
                                No records in this domain.
                            </p>
                            <p class="mb-0 pb-0" v-if="dnsRecordList.length > 0">
                                <router-link :to="{ name: 'account-edit-dns', params: { accountId: this.$route.params.accountId, domain: this.$route.params.domain } }">See DNS records</router-link>
                                <!-- <template v-for="(item, idx) in dnsRecordList">
                                    <v-chip :key="idx">{{ item.type }} {{ item.key }} {{ item.name }} {{ item.value }}</v-chip>
                                </template> -->
                            </p>
                            </template>

                            <p class="text-overline mb-0 mt-4">Confirmation</p>

                            <p>Tap on the button below to delete this domain, including all DNS records, and other related data.</p>

                            <v-alert type="warning" border="left" dense>
                                <template #prepend>
                                    <font-awesome-icon fixed-width :icon="['fas', 'exclamation-triangle']" class="white--text text-body-1"/>
                                </template>
                                <span class="font-weight-bold ml-2">This action is not reversible.</span>
                            </v-alert>

                            <v-checkbox color="amber darken-2" v-model="deleteConfirmation1" label="I want to delete my domain and all associated data" class="mt-0"></v-checkbox>
                            <v-checkbox color="amber darken-2" v-model="deleteConfirmation2" label="I understand this will also unpublish all public and private DNS records for this domain hosted by LibertyDNS, and that my website or other network services may become unreachable" class="mt-0"></v-checkbox>
                            <v-checkbox color="amber darken-2" v-model="deleteConfirmation3" label="I understand this action is not reversible, and that customer support will not be able to help me recover the data." class="mt-0"></v-checkbox>
                            <v-btn color="red" class="white--text" @click="deleteDomain" :disabled="!isDeleteDomainConfirmed">Delete Domain</v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style>
table.kv {
    border-style: none;
}
table.kv tr {
    border-style: none;
}
table.kv th {
    text-align: start;
    white-space: nowrap;
    padding-left: 0px;
    padding-right: 8px;
}
table.kv td {
    text-align: start;
    padding-left: 8px;
    padding-right: 8px;
}
</style>

<script>
import { mapState } from 'vuex';
import AccessDeniedOverlay from '@/components/AccessDeniedOverlay.vue';
import DomainBar from '@/components/DomainBar.vue';

export default {
    components: {
        AccessDeniedOverlay,
        DomainBar,
    },
    data: () => ({
        account: null,
        domain: null,
        dnsRecordList: null,
        error: null,
        deleteConfirmation1: false,
        deleteConfirmation2: false,
        deleteConfirmation3: false,
        forbiddenError: false,
    }),
    computed: {
        ...mapState({
            session: (state) => state.session,
            user: (state) => state.user,
        }),
        isPermitServiceAdmin() {
            return Array.isArray(this.user?.permit?.role) && this.user.permit.role.includes('service-admin');
        },
        isDeleteDomainConfirmed() {
            return this.deleteConfirmation1 && this.deleteConfirmation2 && this.deleteConfirmation3;
        },
    },
    methods: {
        async loadAccount() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadAccount: true });
                const response = await this.$client.account(this.$route.params.accountId).self.get();
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.account = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                if (err.response?.status === 403) {
                    this.forbiddenError = true;
                }
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadAccount: false });
            }
        },
        async loadDomain() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDomain: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.get({ name: this.$route.params.domain });
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.domain = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadDomain: false });
            }
        },
        async loadDnsRecordList() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDomainList: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.searchDnsRecord({ domain: this.$route.params.domain });
                if (Array.isArray(response.list)) {
                    this.dnsRecordList = response.list;
                }
            } catch (err) {
                console.error('failed to load account list', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadDomainList: false });
            }
        },
        async deleteDomain() {
            try {
                this.$store.commit('loading', { deleteDomain: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.delete({ name: this.$route.params.domain });
                if (response?.status?.isDeleted) {
                    this.$bus.$emit('snackbar', { type: 'info', headline: 'Deleted domain', message: this.$route.params.domain });
                    this.$router.push({ name: 'account-dashboard', params: { accountId: this.$route.params.accountId } });
                } else {
                    this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to delete domain', message: this.$route.params.domain });
                }
            } catch (err) {
                console.error('failed to delete account', err);
                this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to delete domain', message: this.$route.params.domain });
            } finally {
                this.$store.commit('loading', { deleteDomain: false });
            }
        },
    },
    mounted() {
        this.loadAccount();
        this.loadDomain();
        this.loadDnsRecordList();
    },
};
</script>
